export default __webpack_public_path__ + "static/media/chaqueta-explorador-hombre.de07ee4e.png";